// src/auth/TokenProbe.jsx
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";

export default function TokenProbe() {
  const { getAccessTokenSilently, loginWithRedirect, isLoading } = useAuth0();

  useEffect(() => {
    if (isLoading) return;

    const probe = async (label) => {
      try {
        // Force a real token fetch (will use refresh token first)
        await getAccessTokenSilently({ cacheMode: "off" });
        // If this succeeds, RT is still good — do nothing
        console.log(`[TokenProbe] ${label}: RT ok`);
      } catch (e) {
        console.log(`[TokenProbe] ${label}: RT expired → redirecting`, e?.error || e);
        // DO NOT try ignoreCache/iframe here — go straight to login
        await loginWithRedirect({
          authorizationParams: { prompt: "login" } // force credentials (optional)
        });
      }
    };

    // Run once on load and when the tab becomes active
    probe("load");
    const onFocus = () => probe("focus");
    const onVisible = () => document.visibilityState === "visible" && probe("visible");
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [getAccessTokenSilently, loginWithRedirect, isLoading]);

  return null;
}
